import React from 'react';

import { Box, CssBaseline } from '@mui/material';
import { styled } from '@mui/material/styles';

import TopBar from '../../navigation/TopBar';
import Sidebar from '../../navigation/Sidebar';
import InvalidProjectsBanner from '../Projects/InvalidProjectsBanner';
import Footer from '../../components/Footer';

const Main = styled('main')({
	flexGrow: 1,
	position: 'relative',
});

const Template: React.FC = (props) => {
	return (
		<Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
			<CssBaseline />
			<TopBar />
			<Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}>
				<Box sx={{ display: 'flex', flexGrow: 1 }}>
					<Sidebar width={240} />
					<Main>
						<Box sx={{ height: '50px' }} />
						<InvalidProjectsBanner />
						<>{props.children}</>
					</Main>
				</Box>
				<Box sx={{ marginLeft: { xs: 0, md: '240px' }, position: 'relative', zIndex: 1 }}>
					<Footer />
				</Box>
			</Box>
		</Box>
	);
};

export default Template;
